








import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'

@Component({
  components: {
    Message: () => import('@/components/message/Message.vue'),
    Modal: () => import('@/components/common/modals/Modal.vue')
  }
})
export default class MessageModal extends Vue {
  $store!: ExStore

  get visible() {
    return this.$store.getters['message/messageModal']
  }

  handleClickClose() {
    this.$emit('change', false)
    this.$store.dispatch('message/displayMessageModal', false)
  }
}
